import { Navigate } from 'react-router-dom';

import { useDefaultLandingPage } from './useDefaultLandingPage';

export function RootRedirect() {
  const defaultLandingPage = useDefaultLandingPage();
  return <Navigate to={defaultLandingPage} replace />;
}
